import React from "react";
import { SiNamecheap } from "react-icons/si";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import { IoPhonePortraitOutline } from "react-icons/io5";
import BranchModel from "../../Models/BranchModel";
import { Link } from "react-router-dom";
function BranchInfo(props: { branch: BranchModel }) {
  const { name } = indexStore();
  const { t } = useTranslation();

  // التأكد من وجود branch
  if (!props.branch || Object.keys(props.branch).length === 0) {
    return (
      <div className="flex flex-col gap-4">
        <h3 className="text-lg font-bold text-foreground border-b border-border pb-2">
          {t("gloabl.branchInfo")}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t("gloabl.noDataAvailable") || "No data available"}
        </p>
      </div>
    );
  }

  // تحديد مفتاح العنوان بناءً على اللغة
  const addressKey = name === "name_en" ? "address_en" : "address_ar";
  const branchName = props.branch[name as keyof BranchModel];
  const address = props.branch[addressKey as keyof BranchModel];

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-bold text-foreground border-b border-border pb-2">
        {t("gloabl.branchInfo")}
      </h3>

      <div className="flex flex-col gap-3">
        {/* اسم الفرع */}
        {branchName && (
          <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors">
            <div className="flex-shrink-0 p-2 rounded-lg bg-primary/10">
              <SiNamecheap className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-base font-semibold text-foreground break-words">
                {branchName}
              </p>
            </div>
          </div>
        )}

        {/* العنوان */}
        {address && (
          <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors">
            <div className="flex-shrink-0 p-2 rounded-lg bg-primary/10">
              <CiLocationOn className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-base font-medium text-foreground break-words">
                {address}
              </p>
            </div>
          </div>
        )}

        {/* الهاتف */}
        <Visibility visible={!!props.branch.phone}>
          <Link
            to={`tel:${props.branch.phone}`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
          >
            <div className="flex-shrink-0 p-2 rounded-lg bg-primary/10">
              <MdOutlinePhoneInTalk className="w-5 h-5 text-primary" />
            </div>
            <p dir="ltr" className="text-base font-medium text-primary">
              {props.branch.phone}
            </p>
          </Link>
        </Visibility>

        {/* الجوال */}
        <Visibility visible={!!props.branch.mobile}>
          <Link
            to={`tel:${props.branch.mobile}`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
          >
            <div className="flex-shrink-0 p-2 rounded-lg bg-primary/10">
              <IoPhonePortraitOutline className="w-5 h-5 text-primary" />
            </div>
            <p dir="ltr" className="text-base font-medium text-primary">
              {props.branch.mobile}
            </p>
          </Link>
        </Visibility>
      </div>
    </div>
  );
}

export default BranchInfo;
